import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {State} from '../../interfaces/result'
import aitems from '../../slices/aitems'
import banner from '../../slices/banner'
import common from '../../slices/common'
import purchaser from '../../slices/purchaser'
import receivableReward from '../../slices/receivableReward'
import recommendationProduct from '../../slices/recommendationProduct'
import reward from '../../slices/reward'

const createRootReducer = (): Reducer<State> =>
    combineReducers({
        aitems,
        banner,
        common,
        purchaser,
        receivableReward,
        recommendationProduct,
        reward,
        router: routerReducer,
    })

export default createRootReducer
